import {ConfigApi, MultistoreLayoutType} from "../../../../services/Api/types";
import StoreUtils from "../../../../services/Store/StoreUtils";
import MultistoreMapPageOldComponent from "./components/Old/MultistoreMapPageOldComponent";
import MultistoreMapPageComponent from "./components/New/MultistoreMapPageComponent";

interface Props {
    config: ConfigApi;
}

const MultistoreMapPage = ({config}: Props) => {
    const layout = StoreUtils.getMultistoreLayoutType(config);

    if (layout === MultistoreLayoutType.BRAND_LIST) return <></>;

    if (!layout) return <MultistoreMapPageOldComponent config={config}/>

    return <MultistoreMapPageComponent config={config}/>
}

export default MultistoreMapPage;